import { FoodItem } from "src/app/services/merchant/food.service.base";

export type FoodItemAvailability = Pick<
  FoodItem,
  "name" | "id" | "profileImageUrl"
> & {
  isAvailable: boolean;
};

export enum OrderStatuses {
  CREATED = "CREATED",
  ACCEPTED = "ACCEPTED",
  CONFIRMED = "CONFIRMED",
  PREPARING = "PREPARING",
  COMPLETE = "COMPLETED",
  READY_FOR_PICKUP = "READY_FOR_PICKUP",
  OUT_FOR_DELIVERY = "OUT_FOR_DELIVERY",
  DELIVERED = "DELIVERED",
  CANCELLED_BY_CUSTOMER = "CANCELLED_BY_CUSTOMER",
  CANCELLED_BY_RESTAURANT = "CANCELLED_BY_RESTAURANT",
  REJECTED_BY_RESTAURANT = "REJECTED_BY_RESTAURANT",
  REFUNDED = "REFUNDED",
}

export interface OrderCustomer {
  id: string;
  name: string;
}

export interface FoodOrderItem {
  item: FoodItem;
  amount: number;
  price: number;
}

export interface Delivery {
  estimateTime: Date;
}

export interface FoodOrderShallow {
  id: string;
  customer: OrderCustomer;
  estimatedReadyAt: Date;
  totalPrice: number;
  finalPrice: number;
  status: OrderStatuses;
  numberOfItems: number;
  readyRemainingTime?: number;
  deliveryRemainingTime?: number;
}

export interface FoodOrderHistory {
  id: string;
  status: OrderStatuses;
  customerName: string;
  updatedById: number;
  createdAt: Date;
  orderNo: number;
  orderPrice: number;
  orderNumberOfItems: number;
}

export interface OrderReview {
  orderId: string;
  id: string;
  customerName: string;
  customerId: string;
  customerProfileImage: string;
  content?: string;
  replyContent?: string;
  rating: number;
  orderTotal: string;
  orderPlacingDate: Date;
  totalLike: number;
  totalDislike: number;
  userTotalOrderFinished: number;
}
